export default __webpack_public_path__ + "static/media/how-to-choose-javascript-framework-for-project.1f0bd6d7.md";